import styles from "./PropertySubtitle.module.scss"
import { PropertySubtitleProps } from "./PropertySubtitle.types"

export default function PropertySubtitle(props: PropertySubtitleProps) {
    const { children } = props

    return <span className={styles.base}>{children}</span>
}
